import securedAxios from '~/javascript/utils/axios'

const axios = securedAxios()

export function getGaStats(websiteId, params = {}) {
  return axios.get(`/ajax/websites/${websiteId}/ga_stats`, { params })
}

export function getGscStats(websiteId, params = {}) {
  return axios.get(`/ajax/websites/${websiteId}/gsc_stats`, { params })
}
